import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import Router from './router'

Vue.config.productionTip = false

Router.beforeEach((to, from, next) => {
/*  if(!Vue.cookie.get('cccf_auth')) {
    window.location = process.env.VUE_APP_SITE_URL
  } else {
    setTimeout(() => app.loading = true, 0)
    next()
  }*/
  next()
})

Router.afterEach(() => {
  setTimeout(() => app.loading = false, 500) // timeout for demo purposes
})

const app = new Vue({
  data: { loading: true },
  router: Router,
  render: h => h(App),
}).$mount('#app')

